<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
            )
                div
                    BaseButton(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nomePrep') }}:
                |
                | {{ restricao.nome_prep || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.cpf') }}:
                |
                | {{ restricao.cpf || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.descricaoFuncao') }}:
                |
                | {{ restricao.descricao_funcao || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataInicioExercicio') }}:
                |
                | {{ restricao.data_inicio_exercicio || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataFimExercicio') }}:
                |
                | {{ restricao.data_fim_exercicio || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataFimCarencia') }}:
                |
                | {{ restricao.data_fim_carencia || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nomeOrgao') }}:
                |
                | {{ restricao.nome_orgao || '-' }}
                Criticidade(
                    v-if='restricao.nivelAlerta'
                    :restricao='restricao'
                )
</template>

<script>
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'pessoa-politicamente-exposta',

    data() {
        return {};
    },

    components: {
        Criticidade,
        BaseButton
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            if (this.restricaoSelecionadaZoomIndex !== index) {
                this.restricaoSelecionadaZoomIndex = index;
                let geometriaQueNaoEstavaDentroDasRestricoes = null;
                if (this.geometria) {
                    geometriaQueNaoEstavaDentroDasRestricoes =
                        this.geometria[index];
                }
                this.$emit(
                    'aplicar-zoom-restricao',
                    this.restricoes[index],
                    geometriaQueNaoEstavaDentroDasRestricoes
                );
            } else {
                this.restricaoSelecionadaZoomIndex = '';
                this.$emit('aplicar-zoom-restricao', null, null);
            }
        }
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>
